import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Row, Table } from "antd";
import { toJS } from "mobx";

@inject('store')
@observer
class rooms extends Component {
    render() {
        const { score = [] } = this.props.store.general;


        const columns = [{
            title: '酒店名称',
            dataIndex: 'name',
            key: 'name',
            width: 150,
        }, {
            title: '携程',
            dataIndex: 'ctrip',
            key: 'ctrip',
            align: "center",
            width: 100,
            sorter: (a, b) => a.ctrip - b.ctrip,
            render: (text, record) => <div style={{ textAlign: "center", paddingRight: 24 }}>{text}</div>
        }, {
            title: '艺龙',
            dataIndex: 'elong',
            key: 'elong',
            align: "center",
            width: 100,
            sorter: (a, b) => a.elong - b.elong,
            render: (text, record) => <div style={{ textAlign: "center", paddingRight: 24 }}>{text}</div>
        }, {
            title: 'booking.com',
            dataIndex: 'book',
            key: 'book',
            align: "center",
            width: 100,
            sorter: (a, b) => a.book - b.book,
            render: (text, record) => <div style={{ textAlign: "center", paddingRight: 24 }}>{text}</div>
        }];

        return (
            <div className="rooms">
                <Row className="score">
                    <div className="total_style">
                        <span>网络评分</span>
                    </div>
                    <Table
                        columns={columns}
                        dataSource={toJS(score)}
                        size="middle"
                        className="content"
                        bordered
                        pagination={false}
                        rowKey={(record, index) => {
                            return index
                        }}
                    />
                </Row>
            </div>
        );
    }
}

export default rooms;


// WEBPACK FOOTER //
// ./src/components/BI/General/NetworkRating.js